<template>
	<div>
		<Card :noHeaderUnderLine="true">
			<template #header>
				<div class="card-item">
					<span class="card-item-label">{{ $t('general.number') }}: </span>
					<span class="card-item-value">{{ order.order_sn }}</span>
				</div>
				<div class="card-item">
					<mt-badge size="small" class="label order-type-buy">{{
						$t('menu.errand_buy')
					}}</mt-badge>
				</div>
				<div class="card-item">
					<mt-badge
						size="small"
						:class="{
							label: true,
							[`order-state-${order.order_state}`]: true,
						}"
						>{{ $t(`order.errand_buy_state.${order.order_state}`) }}</mt-badge
					>
				</div>
			</template>
			<template #content>
				<div class="card-item">
					<div class="d-flex">
						<div class="item store-avatar-item">
							<img
								class="store-avatar"
								:src="order.extend_store.store_avatar || ''"
							/>
						</div>
						<div class="item">
							<div class="d-flex">
								<div class="item">
									<p class="store-name">{{ order.extend_store.store_name }}</p>
								</div>
							</div>
							<p class="order-tips">
								{{ $t('order.goods_count', [goodsCount]) }} | {{ $t('order.total_amount') }}:
								{{ order.order_amount | moneyFilter }}{{ $t('general.dollar') }}
							</p>
							<p class="order-date">
								{{ order.add_time | fromUnixToDateTimeFilter }}
							</p>
						</div>
					</div>
				</div>
			</template>
			<template #footer>
				<div class="operators">
					<mt-button class="common-btn default badge" @click="redirectOrderDetailPage">
						{{ $t('order.order_detail') }}<div class="badge-red" v-if="hasUnreadMessages"></div>
					</mt-button>
					<mt-button
						class="common-btn default"
						v-if="order.if_lock && order.extend_refund"
						@click.native="goRefund(order.extend_refund.refund_id)"
						>{{ $t('order.refunding') }}</mt-button
					>
					<mt-button
						class="common-btn default"
						v-if="order.if_cancel"
						@click.native="cancel(order.order_id)"
						>{{ $t('order.cancel') }}</mt-button
					>
					<mt-button
						class="common-btn default"
						v-if="order.if_refund_cancel"
						@click.native="refund(order.order_id)"
						>{{ $t('order.refund') }}</mt-button
					>
					<mt-button
						class="common-btn default"
						v-if="order.if_receive"
						@click.native="
							showMessage(order.o2o_order_receive_code, $t('order.deliver_code'))
						"
						>{{ $t('order.deliver_code') }}</mt-button
					>
					<mt-button
						class="common-btn info"
						v-if="order.if_evaluation"
						@click.native="evaluate(order.order_id)"
						>{{ $t('order.comment') }}</mt-button
					>
					<mt-button
						class="common-btn primary"
						v-if="order.finnshed_time && !order.order_is_complaint"
						@click.native="complaint(order.order_id)"
						>{{ $t('order.complain') }}</mt-button
					>
					<!-- <mt-button
						class="common-btn danger"
						v-if="order.if_delete"
						@click.native="removeOrder(order.order_id)"
						>{{ $t('order.delete') }}</mt-button
					> -->
					<mt-button
						class="common-btn primary"
						v-if="is_non_payment"
						@click.native="openPaymentConfirmModal({
                            choosePayment: true,
                            paymentDetail: {
                                serialNumber: order.pay_sn,
                                paymentCode: order.payment_code,
                                orderType: ErrandOrderType.BUY,
                            },
                            sellOutOption: order.sold_out_option
                        })">{{ $t('order.pay') }}</mt-button
					>
				</div>
			</template>
		</Card>
	</div>
</template>

<script>
import { fromUnixToDateTimeFilter, moneyFilter } from '@/util/filter'
import Card from '@/components/basic/card'
import { MessageBox } from 'mint-ui'
import { OrderState, ErrandOrderType } from '@/const/order'
import { cancelOrder, deleteOrder } from '@/api/memberOrder'
import { addComplaint } from '@/api/memberO2oCompliant'
import { mapActions, mapGetters, mapState } from 'vuex'
export default {
	name: 'ErrandOrderBuyCard',
	props: ['order'],
	sockets: {
		sendMessage: function (payload) {
			if (payload.roomId === this.order.room_id) {
				this.hasUnreadMessages = true
			}
		}
	},
	components: {
		Card
	},
	data: function () {
		return {
			ErrandOrderType,
			hasUnreadMessages: false,
			modal_visible: {
				confirm: false
			}
		}
	},
	filters: {
		fromUnixToDateTimeFilter,
		moneyFilter
	},
	computed: {
		...mapState({
			rooms: (state) => state.chatroom.rooms
		}),
		...mapGetters([
			'getUnreadCount'
		]),
		is_non_payment: function () {
			return this.order && Number(this.order.order_state) === OrderState.NEW
		},
		goodsCount: function () {
			let count = 0
			for (let i in this.order.extend_order_goods) {
				count += this.order.extend_order_goods[i].goods_num
			}
			return count
		}
	},
	mounted: function () {
		const _this = this

		// 當從信用卡列表返回時，預設顯示付款功能
		if (_this.$route.query.whenGoBackShowPaymentConfirmModal && _this.order && _this.$route.params.order) {
			if (_this.order.errand_order_type === _this.$route.params.order.errand_order_type && _this.order.order_id === _this.$route.params.order.order_id) {
				_this.openPaymentConfirmModal({ choosePayment: true, order: _this.order })
			}
		}
		setTimeout(() => {
			_this.$socket.emit('getRoomIdByOrder', _this.getRoomIdParams(_this.order, 'admin'), function (res) {
				if (res.code === 0) {
					_this.order.room_id = res.results.roomId
					_this.hasUnreadMessages = _this.getUnreadCount(_this.order.room_id, 'admin') > 0
				}
			})
		}, 1500)
	},
	methods: {
		...mapActions([
			'openPaymentConfirmModal',
			'closePaymentConfirmModal'
		]),
		getRoomIdParams (val, toClientType) {
			return {
				toClientType: toClientType,
				orderId: Number(val.o2o_errand_order_id || val.order_id),
				orderType: val.errand_order_type
			}
		},
		redirectOrderDetailPage () {
			this.$router.push(`/member/order_detail?order_id=${this.order.order_id}`)
		},
		showMessage (message, title) {
			MessageBox.alert(message, title)
		},
		goRefund (refundId) {
			this.$router.push({ name: 'MemberRefundView', query: { refund_id: refundId } })
		},
		removeOrder (orderId) {
			const _this = this
			MessageBox.confirm(this.$t('order.confirm_delete') + '？').then((action) => {
				deleteOrder(orderId)
					.then((res) => {
						if (res.code === 10000) {
							_this.$emit('refresh')
							_this.$alert.success(`${this.$t('general.delete_successful')}！`)
						} else {
							_this.$alert.error(res.message)
						}
					})
					.catch(function (error) {
						_this.$alert.error(error.message)
					})
			})
		},
		cancel (orderId) {
			MessageBox.confirm(this.$t('order.confirm_cancel') + '？').then((action) => {
				cancelOrder(orderId)
					.then((res) => {
						this.$router.go(0)
					})
					.catch(function (error) {
						this.$alert.error(error.message)
					})
			})
		},
		refund (orderId) {
			this.$router.push({ name: 'MemberRefundForm', query: { order_id: orderId } })
		},
		evaluate (orderId) {
			this.$router.push({ name: 'MemberOrderEvaluate', params: { order_id: orderId } })
		},
		complaint (orderId) {
			MessageBox.prompt(this.$t('order.complain_content'), '').then(({ value, action }) => {
				if (value) {
					addComplaint(orderId, 0, value)
						.then((res) => {
							this.$alert.success(res.message)
							this.$router.push({ name: 'MemberO2oComplaint' })
						})
						.catch(function (error) {
							this.$alert.error(error.message)
						})
				}
			})
		}
	}
}
</script>

<style lang="scss" scoped>
$nonPaymentColor: #77cef4;
$noteColor: #a6a6a6;
$grayColor: #606060;

.d-flex {
	width: 100%;
	display: flex;
	.item {
		flex: 1 1 auto;
	}
}

.label {
	padding: 0.3rem 0.5rem;
	width: auto;
	border-radius: 30px !important;
}
.order-type-buy {
	background-color: $nonPaymentColor;
}
.card-item {
	.order-tips {
		margin-top: 1rem;
		font-size: 0.7rem;
		color: #7e8c8d;
	}
	.order-date {
		font-size: 0.6rem;
		margin: 0.5rem 0;
		color: #7e8c8d;
	}
	.store-avatar-item {
		text-align: center;
	}
	.store-avatar {
		width: 90px;
		height: 90px;
		border-radius: 50%;
	}
	.store-name {
		color: black;
		margin-top: 0.2rem;
		font-size: 0.8rem;
		font-weight: bold;
	}
}
</style>
